import { render, staticRenderFns } from "./RiskCheckDailySafetyChecklist.vue?vue&type=template&id=0a137ea1&scoped=true"
import script from "./RiskCheckDailySafetyChecklist.vue?vue&type=script&lang=js"
export * from "./RiskCheckDailySafetyChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a137ea1",
  null
  
)

export default component.exports